export const AUTH_SESSION_ACTIVE_KEY = 'zenosAuthSessionActive';

/** Client hint that an HttpOnly auth cookie may exist (survives new tabs). */
export function markAuthSessionActive() {
  if (typeof window === 'undefined') return;

  localStorage.setItem(AUTH_SESSION_ACTIVE_KEY, '1');
}

export function clearAuthSessionActive() {
  if (typeof window === 'undefined') return;

  localStorage.removeItem(AUTH_SESSION_ACTIVE_KEY);
}

export function hasAuthSessionActive() {
  if (typeof window === 'undefined') return false;

  return localStorage.getItem(AUTH_SESSION_ACTIVE_KEY) === '1';
}

export function isAuthSessionValid(expiry?: number) {
  return !!expiry && expiry > Date.now();
}
